import { observer } from "mobx-react-lite";
import ProductTypePageStyled from "./product-type.page.styled";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useStore } from "../../../../hooks/store.hook";
import { PanelType } from "../../../../enums/panel-type.enum";
import TableComponent, { ActionItemPropsType, CustomRendererPropsType, TableDataPropsType } from "../../../../components/table/table.component";
import { HeaderTypeEnum } from "../../../../enums/header-type.enum";
import { EditOutlined } from "@mui/icons-material";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import PageTemplateComponent from "../../../../components/page-template/page-template.component";
import { TableTypeEnum } from "../../../../enums/table-type.enum";
import ProductTypePanel from "../../../../components/product-type/product-type-panel.component";
import { getDictionaryProductCategoryTypes, getProductTypes } from "../../../../utils/requests";
import { displayCustomToast } from "../../../../utils/display-custom-toast";
import { isEmpty } from "lodash";

const ProductTypePage = observer(() => {

    const [refreshData, setRefreshData] = useState<boolean>(true);
    const [data, setData] = useState<any>();
    const [dataLoading, setDataLoading] = useState<boolean>(true);
    const [filtersTable, setFilters] = useState<any>({
          pageIndex: 0,
          pageSize: 5,
          selectFilterValue: null,
        //   secondSelectFilterValue: null,
        //   tabFilterValue: undefined,
          searchText: null
    });
    const uiStore = useStore('uiStore');
    const [actionItemsClick, setActionItemsClick] = useState<any>();
    const [productCategoryTypes, setProductCategoryTypes] = useState<any[]>([]);

    const getBasicSelectOptions = async () => {
        try {

            let productCategoryTypes = await getDictionaryProductCategoryTypes();
            
            setProductCategoryTypes(() => productCategoryTypes);

        } catch (error: any) {

            displayCustomToast(error.content, true);
        }
    }
    
    useEffect(
        () => {
            async function getData() {
                try {
                    setDataLoading(() => true)

                    await getBasicSelectOptions();

                    let fetchJobs = await getProductTypes({
                        pageIndex: filtersTable.pageIndex + 1,
                        pageSize: filtersTable.pageSize,
                        searchText: filtersTable.searchText,
                        productCategoryTypeId: isEmpty(filtersTable.selectFilterValue) ? null : filtersTable.selectFilterValue.value
                    });
                    setData(() => fetchJobs)
                    setDataLoading(() => false)
                } catch (error: any) {
                    displayCustomToast(error.content, true);
                    setDataLoading(() => false)
                }
            }
            
            if(!refreshData) return;

            getData();
            setRefreshData(() => false);
            
        },
        [filtersTable, refreshData]
    )

    const createData = useCallback(
        () => {
            uiStore.openPanel({
                key: PanelType.CreateProducType,
                component: <ProductTypePanel />,
                panelWidth: '700px',
                title: `Creare tip produs`,
                onDismiss: (data: any) => {
                    if(!data) return;
                    
                    if(data?.refreshData)
                        setRefreshData(() => true);
                }
            });
        },
        []
    )

    const tableData = useMemo(
        (): TableDataPropsType => {
            if(!data) return {
                data: [],
                headers: []
            }

            return {
                data: data.data,
                headers: [
                   {
                        id: 'name',
                        label: 'Nume',
                        headerType: HeaderTypeEnum.String,
                        alignment: 'left',
                        sortable: false
                    },
                   {
                        id: 'productCategoryType',
                        label: 'Tip categorie produs',
                        headerType: HeaderTypeEnum.String,
                        alignment: 'left',
                        sortable: false
                    },
                   {
                        id: 'measurementUnitType',
                        label: 'Tip unitate de masura',
                        headerType: HeaderTypeEnum.String,
                        alignment: 'left',
                        sortable: false
                    },
                    {
                        id: 'hasBatch',
                        label: 'Are lot',
                        headerType: HeaderTypeEnum.Boolean,
                        alignment: 'center',
                        sortable: false
                    },
                    {
                        id: 'isActive',
                        label: 'Activ',
                        headerType: HeaderTypeEnum.Boolean,
                        alignment: 'center',
                        sortable: false
                    }
                ],
                totalElements: data.totalNumber
            }
        },
        [data]
    )

    const actionItems: ActionItemPropsType[] = useMemo(
        () => {
            return [
                {
                    text: "Editeaza",
                    icon: <EditOutlined />,
                    color: "black",
                    fOnClick: (row: any) => {
                        uiStore.openPanel({
                            key: PanelType.EditBatch,
                            component: <ProductTypePanel
                                productTypeId={row.id}
                                productTypeDetails={row}
                            />,
                            panelWidth: '700px',
                            title: `Editeaza: ${row.name}`,
                            onDismiss: (data: any) => {
                                if(!data) return;
                                
                                if(data?.refreshData)
                                    setRefreshData(() => true);
                            }
                        });
                    }
                }
            ]
        },
        [actionItemsClick]
    )

    const customRenderer: CustomRendererPropsType = useMemo(
        () => {
            return {
                isActive: (row: any) => {
                    return (
                        <>
                            {
                                row.isActive ?
                                    <CheckIcon color="success"  />
                                    :
                                    <CloseIcon color="error"  />
                            }
                        </>
                    )
                },
                hasBatch: (row: any) => {
                    return (
                        <>
                            {
                                row.hasBatch ?
                                    <CheckIcon color="success"  />
                                    :
                                    <CloseIcon color="error"  />
                            }
                        </>
                    )
                },
                productCategoryType: (row: any) => {
                    return (
                        <>
                            {row.productCategoryType.name}
                        </>
                    )
                },
                measurementUnitType: (row: any) => {
                    return (
                        <>
                            {row.measurementUnitType.name}
                        </>
                    )
                },
            }
        },
        []
    )

    return (
        <ProductTypePageStyled>
            <PageTemplateComponent 
                title="Tipuri de produse"
                buttons={[
                    {
                        fOnClick: () => {
                            createData()
                        },
                        text: "Creeaza"
                    }
                ]}
            >
                <TableComponent
                    tableKey={TableTypeEnum.AllProductTypes} 
                    viewType="normal"
                    tableData={tableData}
                    searchBarPlaceholder="Cauta dupa nume"
                    withoutSelect
                    dropdownPlaceholder="Tip categorie produs"
                    dropdownOptions={productCategoryTypes?.map(p => ({
                        label: p.name,
                        value: p.id
                    }))}
                    isLoading={dataLoading}
                    tableState={filtersTable}
                    setTableState={setFilters}
                    actionItems={actionItems}
                    actionItemsClick={setActionItemsClick}
                    setRefreshData={setRefreshData}
                    customRenderer={customRenderer}
                />
            </PageTemplateComponent>
        </ProductTypePageStyled>
    )
});

export default ProductTypePage;